import { render, staticRenderFns } from "./aFeeDetailConfig.vue?vue&type=template&id=78fd56b7&scoped=true"
import script from "./aFeeDetailConfig.vue?vue&type=script&lang=js"
export * from "./aFeeDetailConfig.vue?vue&type=script&lang=js"
import style0 from "./aFeeDetailConfig.vue?vue&type=style&index=0&id=78fd56b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd56b7",
  null
  
)

export default component.exports